import { InputRow } from './InputRow';

export function YieldReferenced({ rx }) {
  return (
    <InputRow
      name={`Yield Referenced`}
      value={[rx.yield1Value, rx.yield2Value].filter(Boolean).join(' / ')}
    />
  );
}
